import React, { useState } from 'react';
import "./loginPage.css";
import LoginForm from "./loginForm/LoginForm";
import ForgotForm from "./forgotForm/ForgotForm";
import { useSearchParams } from 'react-router-dom';

import BubbleBackground from '../../components/BubbleBackground';

export default function LoginPage() {
    
    const [showForgotForm, setShowForgotForm] = useState(false);
    const [showExpiredTokenMessage, setShowExpiredTokenMessage] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams()
    const token = searchParams.get('token')

    if (token === 'expired' && !showExpiredTokenMessage) {
        setShowExpiredTokenMessage(true);
      }




    const handleForgotPasswordClick = () => {
        setShowForgotForm(true);
    };

    const handleGoToLoginClick = () => {
        setShowForgotForm(false);
    };

        return (
            <div className={"login-main-layout centered-layout"} style={{ position: 'relative', zIndex: 1 }}>
                <BubbleBackground />
                <div style={{ position: 'relative', zIndex: 2, width: '100%' }}>
                    {showForgotForm ? (
                        <div className={"forms-container"}>
                            <ForgotForm onClose={() => setShowForgotForm(false)} />
                            <button className={"GoToLogin-button"} onClick={handleGoToLoginClick}>
                                Ir al Login
                            </button>
                        </div>
                    ) : (
                        <div className={"forms-container"}>
                            {showExpiredTokenMessage && (
                                <div className={"alert-box"}>
                                    Tu sesión ha caducado.<br />
                                    Loguéate de nuevo
                                </div>
                            )}
                            <LoginForm onForgotClick={handleForgotPasswordClick} />
                        </div>
                    )}
                </div>
            </div>
        );
}